import { render, staticRenderFns } from "./TaskLabel.vue?vue&type=template&id=b9f44a0a&scoped=true"
import script from "./TaskLabel.vue?vue&type=script&lang=js"
export * from "./TaskLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9f44a0a",
  null
  
)

export default component.exports